import { SlateKit } from './slate-kit';
export * as blocks from './blocks';
export default SlateKit;
//# sourceMappingURL=index.js.map